export const ApiStatus = {
  SUCCESS: '001',
  AUTHENTION_ERROR: '002',
  VALIDATE_ERROR: '003',
  DELETE_ERROR: '004',
  NOT_EXISTS : '005',
  PERMISSION_DENIED : '006',
  CANNOT_ANSWER : '007',
  EXAM_STATUS_ERROR : '008',
  UPDATE_ERROR : '009',
  CREATE_ERROR : '010',
  GET_ERROR : '011',
  UNKNOW_ERROR: '999'
}

export enum RequestMode {
  DEFAULT = 'default',
  LIST = 'list',
  DETAIL = 'detail',
  TEST = 'test',
  MY_EXAM = 'my_exam',
  INDEX = 'index',
  EXAM_SUMMARY = 'exam_summary',
}
